import { EndpointInterface } from '../../core/Endpoint'
import {
  DEFAULT_CLINICS_MANAGER_API_VERSION,
  ENDPOINT_CLINICS_MANAGER_CLINIC,
  ENDPOINT_CLINICS_MANAGER_CLINICS,
} from '../constants'
import {
  ClinicsManagerClinicGetResponse,
  ClinicsClinicsGetResponse,
  ClinicsPutClinicPayload,
} from '../types'

export const getClinics =
  (): EndpointInterface<ClinicsClinicsGetResponse> => (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_CLINICS_MANAGER_CLINICS,
        params: [DEFAULT_CLINICS_MANAGER_API_VERSION],
      },
      method: 'get',
    })

export const getClinicsManagerClinic =
  ({
    clinicId,
  }: {
    clinicId: string | number
  }): EndpointInterface<ClinicsManagerClinicGetResponse> =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_CLINICS_MANAGER_CLINIC,
        params: [DEFAULT_CLINICS_MANAGER_API_VERSION, clinicId],
      },
      method: 'get',
    })

export const putClinic =
  (
    clinicId: string | number,
    data: ClinicsPutClinicPayload,
    version: string = DEFAULT_CLINICS_MANAGER_API_VERSION,
  ): EndpointInterface<void> =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_CLINICS_MANAGER_CLINIC,
        params: [version, clinicId],
      },
      method: 'put',
      data,
    })
